export class TrialAlreadyUsedError extends Error {

  code?: string = 'reservation/trial-used';
}
